module.exports = __webpack_public_path__ + "Roboto-Bold.dc81817def276b4f2139.woff";


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/font/roboto/Roboto-Bold.woff
// module id = ../../../../../src/libs/mdbootstrap/font/roboto/Roboto-Bold.woff
// module chunks = styles